import { BlockViewExtension } from '@blocksuite/affine/block-std';
import type { ExtensionType } from '@blocksuite/affine/store';
import { literal } from 'lit/static-html.js';

export const DeepResearchResultBlockSpec: ExtensionType[] = [
  BlockViewExtension(
    'affine:deep-research-result',
    () => literal`affine-deep-research-result`
  ),
];
